import classNames from 'classnames';
import { memo, useMemo } from 'react';
import { glyphSegmentsPath } from '../../potree/sketchObjects/typeIcon';

const SIZE = 64;

interface GlyphPreviewProps {
  /** Flat `[x1,y1,z, x2,y2,z, …]` glyph segments (any scale; fitted to the box). */
  segments: readonly number[];
  className?: string;
}

/** A glyph drawn with `currentColor`, fitted into a square: library cards, template tiles. */
const GlyphPreview_: React.FC<GlyphPreviewProps> = ({ segments, className }) => {
  const d = useMemo(() => glyphSegmentsPath(segments, SIZE, 4), [segments]);
  return (
    <svg viewBox={`0 0 ${SIZE} ${SIZE}`} className={classNames('w-full h-full', className)} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {d && <path d={d} fill="none" stroke="currentColor" strokeWidth={1.2} strokeLinecap="round" vectorEffect="non-scaling-stroke" />}
    </svg>
  );
};

export const GlyphPreview = memo(GlyphPreview_);
